import React, { useRef } from 'react';
import styled from 'styled-components';
import {
  ArrowButtons,
  Breakpoints,
  BreakpointWrapper,
  Container,
  ContainerPadding,
  Gallery as CoreGallery,
  GallerySlide,
  Text,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { Acceleration, ChevronLeft, ChevronRight, Engine, PopularCarPrivate, Powertrain, TestDrive } from '@volkswagen-onehub/icons-core';
import ScrollHintArrow from '../ScrollHintArrow';

type Feature = {
  title: string;
  description: string;
  icon: React.ReactNode;
};

const FEATURES: Feature[] = [
  {
    title: 'MOTOR DEPORTIVO',
    description:
      'El Golf GTI tiene 265CV de potencia, acelera de 0 a 100km/h en menos de 6 segundos y alcanza una velocidad máxima de 250km/h. Tiene un motor deportivo, transmisión DSG de 7 velocidades y pura adrenalina en el acelerador.',
    icon: <Acceleration variant="default" aria-hidden />,
  },
  {
    title: 'ACABADO GTI',
    description:
      'Si eliges el acabado GTI, tendrás un modelo deportivo, pero equilibrado. Con detalles de diseño que lo hacen único, es la mejor opción para saborear la adrenalina en momentos especiales y también en el día a día.',
    icon: <PopularCarPrivate variant="default" aria-hidden />,
  },
  {
    title: 'ACABADO CLUBSPORT',
    description:
      'Si te quedas con el acabado Clubsport, descubrirás qué es la deportividad y efectividad pura, tanto por sus 300CV de potencia como por su tren de rodaje con mayores frenos y suspensión adaptativa de serie.',
    icon: <TestDrive variant="default" aria-hidden />,
  },
];

const ROTATION_IMAGES = [
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_000_6%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 000 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_030_12%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 030 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_060_5%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 060 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_090_9%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 090 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_120_7%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 120 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_150_2%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 150 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_180_11%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 180 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_210_4%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 210 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_240_1%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 240 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_270_3%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 270 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_300_10%201?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 300 grados',
  },
  {
    src: 'https://assets.volkswagen.com/is/image/volkswagenag/GTI__images_30602_AVP2D_A_360_330_8%202?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx',
    alt: 'Volkswagen Golf GTI 50 vista 330 grados',
  },
];

const RootSection = styled.section`
  position: relative;
`;

const SectionContainer = styled(Container)`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(90deg, rgba(0, 0, 0, 0.78) 0%, rgba(0, 0, 0, 0.28) 36%, rgba(0, 0, 0, 0.82) 100%),
    url('https://assets.volkswagen.com/is/image/volkswagenag/detail-gti-background?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT0xMDgwJmZtdD1wbmctYWxwaGEmYmZjPW9mZiY1M2Qx');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #ffffff;
`;

const ScrollHintArrowLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  width: min(100%, 420px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: 560px) {
    width: min(100%, 720px);
  }

  @media screen and (min-width: 960px) {
    width: min(1240px, calc(100vw - 96px));
    grid-template-columns: minmax(320px, 702px) minmax(280px, 1fr);
    gap: clamp(32px, 5vw, 96px);
  }
`;

const GalleryColumn = styled.div`
  position: relative;
  min-width: 0;
  width: 100%;
`;

const OutlineTitle = styled.span`
  position: absolute;
  top: -18px;
  left: 4vw;
  font-family: 'Futura Condensed Extra Bold', Futura, Arial, sans-serif;
  font-size: clamp(86px, 30vw, 140px);
  line-height: 0.85;
  color: transparent;
  -webkit-text-stroke: 1px rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
  pointer-events: none;
  z-index: 2;

  @media screen and (min-width: 960px) {
    top: clamp(-40px, -3vw, -8px);
    left: clamp(-18px, -2vw, 0px);
    font-size: clamp(110px, 16vw, 240px);
  }
`;

const GalleryCard = styled.div`
  position: relative;
  z-index: 1;
  width: min(100%, 120vw, 296px);
  margin: 0 auto;

  @media screen and (min-width: 560px) {
    width: min(100%, 78vw, 720px, calc((100vh - 160px) * 0.823));
  }

  @media screen and (min-width: 960px) {
    width: min(1040px, calc(100% - 16px), calc((100vh - 56px) * 0.823));
  }
`;

const GalleryInnerCard = styled.div`
  background: #c90010;
  border-radius: 12px;
  padding: 18px 10px 16px;
  aspect-ratio: 800 / 972;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;

  @media screen and (min-width: 560px) {
    padding: 18px 14px 16px;
  }

  @media screen and (min-width: 960px) {
    padding: clamp(12px, 1.3vw, 20px);
  }
`;

const ImageViewport = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledGallery = styled(CoreGallery)`
  [class*='sc-196wn05'] {
    box-sizing: border-box;
    padding-inline: clamp(10px, 2.4vw, 22px);
  }

  [class*='StyledContainedImageWrapper'] {
    width: 100% !important;
  }
`;

const SlideContent = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: clamp(320px, 78vw, 480px);
  padding: 8px 0;

  @media screen and (min-width: 960px) {
    height: 100%;
    min-height: 0;
    padding: 0;
  }
`;

const CarImage = styled.img`
  width: min(120%, 720px);
  height: auto;
  object-fit: contain;
  user-select: none;
  pointer-events: none;

  @media screen and (min-width: 560px) {
    width: min(100%, 900px);
  }

  @media screen and (min-width: 960px) {
    height: clamp(558px, 39.6vw, 774px);
    width: auto;
    max-width: min(117%, 1224px);
  }
`;

const ArrowButtonsWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  justify-content: center;
  width: calc(100% + 90px);
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 0 8px;

  @media screen and (min-width: 560px) {
    padding: 0 16px;
    width: calc(100% + 120px);
  }

  @media screen and (min-width: 960px) {
    padding: 0 56px;
  }

  button {
    background-color: #c90010 !important;
    border-color: #c90010 !important;
  }

  button:hover {
    background-color: #ffffff !important;
    border-color: #ffffff !important;
  }

  button * {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  button:hover * {
    color: #c90010 !important;
    fill: #c90010 !important;
  }

  button:disabled,
  button[disabled] {
    background-color: #8a010c !important;
    border-color: #8a010c !important;
    opacity: 0.8 !important;
  }
`;

/* Galeria personalizada aparcada temporalmente.
const ArrowIconStyles = `
  color: currentColor;
  fill: currentColor;
`;

const ArrowIcon = styled(ChevronLeft)`
  ${ArrowIconStyles}
`;
*/

const FeatureColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  @media screen and (min-width: 960px) {
    gap: clamp(28px, 3vw, 40px);
  }
`;

const FeatureItem = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  max-width: 34ch;
  margin: 0 auto;

  @media screen and (min-width: 960px) {
    gap: 12px;
    max-width: 480px;
  }
`;

const IconWrap = styled.div`
  color: #c90010;
  display: none;

  & svg {
    width: clamp(42px, 5vw, 58px);
    height: clamp(42px, 5vw, 58px);
  }

  @media screen and (min-width: 960px) {
    display: block;
  }
`;

const FeatureTitle = styled(Text)`
  font-family: 'Futura Condensed Extra Bold', Futura, Arial, sans-serif;
  color: #ffffff;
  text-transform: uppercase;
`;

const FeatureDescription = styled(Text)`
  color: rgba(255, 255, 255, 0.88);
  max-width: 30ch;
  text-align: center;

  @media screen and (min-width: 960px) {
    max-width: 44ch;
  }
`;

export const Gallery = (): React.ReactElement => {
  return (
    <ImageViewport aria-label="Galeria 360 del Volkswagen Golf GTI 50" role="region">
      <GalleryCard>
        <StyledGallery
          id="detail-gti50-gallery1"
          aria-label="Galeria 360 del Volkswagen Golf GTI 50"
          fadingEdges="none"
          endlessScrolling
          gutter="grid002"
          bottomElements={
            <ArrowButtonsWrapper id="detail-gti50-gallery1-arrow-buttons">
              <ArrowButtons buttonPreviousAriaLabel="Vista anterior" buttonNextAriaLabel="Vista siguiente" />
            </ArrowButtonsWrapper>
          }
        >
          {ROTATION_IMAGES.map((image, index) => (
            <GallerySlide key={image.src} aria-labelledby={`detail-gti50-gallery1-slide-${index}`}>
              <GalleryInnerCard>
                <SlideContent>
                  <CarImage id={`detail-gti50-gallery1-slide-${index}`} src={image.src} alt={image.alt} />
                </SlideContent>
              </GalleryInnerCard>
            </GallerySlide>
          ))}
        </StyledGallery>
      </GalleryCard>
    </ImageViewport>
  );
};

export const DetailGti50 = (): React.ReactElement => {
  const sectionRef = useRef<HTMLElement | null>(null);

  return (
    <RootSection id="detail-gti50-module" ref={sectionRef}>
      <SectionContainer
        padding={{
          top: ContainerPadding.dynamic0300,
          bottom: ContainerPadding.dynamic0300,
        }}
      >
        <Content>
          <GalleryColumn>
            <OutlineTitle aria-hidden>GTI</OutlineTitle>

            <Gallery />

            {/* 
            <ImageViewport aria-label="Galeria 360 del Volkswagen Golf GTI 50" role="region">
              <GalleryCard>
                <SlideContent>
                  <CarImage src={activeImage.src} alt={activeImage.alt} />
                </SlideContent>
              </GalleryCard>

              <ArrowButtonsWrapper>
                <ArrowButtonRow>
                  <ArrowButton type="button" aria-label="Vista anterior" onClick={showPreviousImage}>
                    <ArrowIcon variant="default" aria-hidden />
                  </ArrowButton>

                  <ArrowButton type="button" aria-label="Vista siguiente" onClick={showNextImage}>
                    <ArrowIcon as={ChevronRight} variant="default" aria-hidden />
                  </ArrowButton>
                </ArrowButtonRow>
              </ArrowButtonsWrapper>
            </ImageViewport>
            */}
          </GalleryColumn>

          <FeatureColumn>
            {FEATURES.map((feature) => (
              <FeatureItem key={feature.title}>
                <IconWrap>{feature.icon}</IconWrap>
                <FeatureTitle appearance={TokenTextAppearance.headline300}>{feature.title}</FeatureTitle>
                <FeatureDescription appearance={TokenTextAppearance.copy100}>{feature.description}</FeatureDescription>
              </FeatureItem>
            ))}
          </FeatureColumn>
        </Content>

        <ScrollHintArrowLayer>
          <ScrollHintArrow trigger={sectionRef} targetSelector="#apuntate-gti50-module" color="#ffffff" />
        </ScrollHintArrowLayer>
      </SectionContainer>
    </RootSection>
  );
};
